module.exports = __webpack_public_path__ + "img/main-page-logo-tat.073deabd.svg";